import React from "react";
import "./TopBanner.css";

export default function TopBanner() {
    return (
        <div className="topbanner-wrapper">

            <div className="topbanner">

                {/* Decorative circles */}
                <div className="banner-circle circle-one"></div>
                <div className="banner-circle circle-two"></div>
                <div className="banner-circle circle-three"></div>

                {/* Left content */}
                <div className="banner-content">

                    <div className="medical-logo">
                        <i className="fa fa-heartbeat"></i>
                    </div>

                    <div className="banner-text">

                        <span className="banner-small-title">
                            MEDICAL MANAGEMENT SYSTEM
                        </span>

                        <h1 className="topheader">
                            Kolath Medical Centre
                        </h1>

                        <p className="banner-subtitle">
                            Patient Care & Visit Management
                        </p>

                    </div>

                </div>

                {/* Right information */}
                <div className="banner-status">

                    <div className="status-icon">
                        <i className="fa fa-check-circle"></i>
                    </div>

                    <div>
                        <span className="status-title">
                            System Active
                        </span>

                        <span className="status-text">
                            Management Portal
                        </span>
                    </div>

                </div>

            </div>

        </div>
    );
}